import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { SenhaModel } from '@shared/models/backend'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class VinculoSupervisorService {
  constructor(private http: HttpClient) {}

  public refreshCaptcha() {
    return this.http.post('/api/public/captcha', {}, { responseType: 'arraybuffer' })
  }

  public getAccess(form, token: string) {
    return this.http.post<number>('/api/public/supervisor/vinculo/' + token + '/access', form).pipe(take(1))
  }

  public needChangePassword(token: string) {
    return this.http.get<boolean>('/api/public/supervisor/vinculo/' + token + '/needChangePassword').pipe(take(1))
  }

  public changePassword(form: SenhaModel, token: string) {
    return this.http.put<boolean>(`/api/authorization/${token}/password`, form).pipe(take(1))
  }
}
